const ReportTypes = {
    // Employee Daily Logs
    GET_EMPLOYEE_DAILY_LOGS: "GET_EMPLOYEE_DAILY_LOGS",
    GET_EMPLOYEE_DAILY_LOGS_SUCCESS: "GET_EMPLOYEE_DAILY_LOGS_SUCCESS",
    GET_EMPLOYEE_DAILY_LOGS_ERROR: "GET_EMPLOYEE_DAILY_LOGS_ERROR",
    
    // Monthly Summary
    GET_MONTHLY_SUMMARY: "GET_MONTHLY_SUMMARY",
    GET_MONTHLY_SUMMARY_SUCCESS: "GET_MONTHLY_SUMMARY_SUCCESS",
    GET_MONTHLY_SUMMARY_ERROR: "GET_MONTHLY_SUMMARY_ERROR",
    
    // Project Daily Summary
    GET_PROJECT_DAILY_SUMMARY: "GET_PROJECT_DAILY_SUMMARY",
    GET_PROJECT_DAILY_SUMMARY_SUCCESS: "GET_PROJECT_DAILY_SUMMARY_SUCCESS",
    GET_PROJECT_DAILY_SUMMARY_ERROR: "GET_PROJECT_DAILY_SUMMARY_ERROR",
    
    // Project Team View
    GET_PROJECT_TEAM_VIEW: "GET_PROJECT_TEAM_VIEW",
    GET_PROJECT_TEAM_VIEW_SUCCESS: "GET_PROJECT_TEAM_VIEW_SUCCESS",
    GET_PROJECT_TEAM_VIEW_ERROR: "GET_PROJECT_TEAM_VIEW_ERROR",
}
export default ReportTypes;